import { MenuItem } from './MenuItem'
import { MenuInnerWithSub } from './MenuInnerWithSub'
import { MegaMenu } from './MegaMenu'
import { useIntl } from 'react-intl'
import { useAuth } from '../../../../app/modules/auth/core/Auth'

export function MenuInner() {
  const intl = useIntl()
  const { currentUser } = useAuth();

  return (
    <>

      {/*<MenuItem title='Layout Builder' to='/builder' />*/}
      {/*
      <MenuInnerWithSub
        title='Crafted'
        to='/crafted'
        menuPlacement='bottom-start'
        menuTrigger='click'
      >
      */}

      {/* PAGES */}
      {/*
        <MenuInnerWithSub
          title='Pages'
          to='/crafted/pages'
          icon='/media/icons/duotune/general/gen022.svg'
          hasArrow={true}
          menuPlacement='right-start'
          menuTrigger={`{default:'click', lg: 'hover'}`}
        >
        */}
      {/*
          <MenuInnerWithSub
            title='Profile'
            to='/crafted/pages/profile'
            hasArrow={true}
            hasBullet={true}
            menuPlacement='right-start'
            menuTrigger={`{default:'click', lg: 'hover'}`}
          >
            <MenuItem to='/crafted/pages/profile/overview' title='Overview' hasBullet={true} />
            <MenuItem to='/crafted/pages/profile/projects' title='Projects' hasBullet={true} />
            <MenuItem to='/crafted/pages/profile/campaigns' title='Campaigns' hasBullet={true} />
            <MenuItem to='/crafted/pages/profile/documents' title='Documents' hasBullet={true} />
            <MenuItem
              to='/crafted/pages/profile/connections'
              title='Connections'
              hasBullet={true}
            />
          </MenuInnerWithSub>
          */}

      {/*
          <MenuInnerWithSub
            title='Wizards'
            to='/crafted/pages/wizards'
            hasArrow={true}
            hasBullet={true}
            menuPlacement='right-start'
            menuTrigger={`{default:'click', lg: 'hover'}`}
          >
            <MenuItem to='/crafted/pages/wizards/horizontal' title='Horizontal' hasBullet={true} />
            <MenuItem to='/crafted/pages/wizards/vertical' title='Vertical' hasBullet={true} />
          </MenuInnerWithSub>
        </MenuInnerWithSub>
        */}
      {/* ACCOUNT */}
      {/*
        <MenuInnerWithSub
          title='Accounts'
          to='/crafted/accounts'
          icon='/media/icons/duotune/communication/com006.svg'
          hasArrow={true}
          menuPlacement='right-start'
          menuTrigger={`{default:'click', lg: 'hover'}`}
        >
          <MenuItem to='/crafted/account/overview' title='Overview' hasBullet={true} />
          <MenuItem to='/crafted/account/settings' title='Settings' hasBullet={true} />
        </MenuInnerWithSub>
      */}
      {/* ERRORS */}
      {/*}
        <MenuInnerWithSub
          title='Errors'
          to='/error'
          icon='/media/icons/duotune/technology/teh004.svg'
          hasArrow={true}
          menuPlacement='right-start'
          menuTrigger={`{default:'click', lg: 'hover'}`}
        >
          <MenuItem to='/error/404' title='Error 404' hasBullet={true} />
          <MenuItem to='/error/500' title='Error 500' hasBullet={true} />
        </MenuInnerWithSub>
        {*/}
      {/* Widgets */}
      {/*}
        <MenuInnerWithSub
          title='Widgets'
          to='/crafted/widgets'
          icon='/media/icons/duotune/general/gen025.svg'
          hasArrow={true}
          menuPlacement='right-start'
          menuTrigger={`{default:'click', lg: 'hover'}`}
        >
          <MenuItem to='/crafted/widgets/lists' title='Lists' hasBullet={true} />
          <MenuItem to='/crafted/widgets/statistics' title='Statistics' hasBullet={true} />
          <MenuItem to='/crafted/widgets/charts' title='Charts' hasBullet={true} />
          <MenuItem to='/crafted/widgets/mixed' title='Mixed' hasBullet={true} />
          <MenuItem to='/crafted/widgets/tables' title='Tables' hasBullet={true} />
          <MenuItem to='/crafted/widgets/feeds' title='Feeds' hasBullet={true} />
        </MenuInnerWithSub>
      </MenuInnerWithSub>
      {*/}

      <MenuItem title={intl.formatMessage({ id: 'MENU.DASHBOARD' })} to='/dashboard' />

      {
        currentUser.userSession.role.name == 'Super Admin' ? (
          <MenuInnerWithSub title='Organizations' to='/organization' menuPlacement='bottom-start' menuTrigger='click'>
            {/* PAGES */}
            <MenuItem
              icon='/media/icons/duotune/general/gen051.svg'
              to='/organizations'
              title='Organizations List'
            />
          </MenuInnerWithSub>
        ) : null
      }

      {
        currentUser.userSession.role.name == 'Super Admin' || currentUser.userSession.role.name == 'Admin' ? (
          <MenuInnerWithSub title='Branches' to='/branches' menuPlacement='bottom-start' menuTrigger='click'>
            {/* PAGES */}
            <MenuItem
              icon='/media/icons/duotune/general/gen051.svg'
              to='/branches'
              title='Branches List'
            />
          </MenuInnerWithSub>
        ) : null
      }

      {/* {
         currentUser.userSession.role.name == 'Super Admin' || currentUser.userSession.role.name == 'Admin' || currentUser.userSession.role.name == 'Sub Admin' ? (
          <MenuInnerWithSub title='Branches (Hospitals)' to='/branches' menuPlacement='bottom-start' menuTrigger='click'>
          <MenuItem
            icon='/media/icons/duotune/general/gen051.svg'
            to='/branches'
            title='Branches List'
          />
        </MenuInnerWithSub>
         ) : null
      } */}



      {/* <MenuInnerWithSub title='Manage' to='/user-management' menuPlacement='bottom-start' menuTrigger='click'>
        <MenuItem
          icon='/media/icons/duotune/general/gen051.svg'
          to='/user-management/users'
          title='User management'
        />
      </MenuInnerWithSub> */}

      {
        currentUser.userSession.user.role_id > 0 && currentUser.userSession.user.role_id < 4 ? (
          <MenuItem title={'Doctors'} to='/doctors' />
        ) : null
      }



      <MenuInnerWithSub title='Settings' to='/settings' menuPlacement='bottom-start' menuTrigger='click'>
        {/* PAGES */}

        {
          currentUser.userSession.user.role_id > 0 && currentUser.userSession.user.role_id < 4 ? (
        <MenuItem to='/settings/user' title='Users' hasBullet={true} />
          ): null }

        {
          currentUser.userSession.role.name == 'Super Admin' ? (
            <>
              <MenuItem to='/settings/permission' title='Permissions' hasBullet={true} />
              <MenuItem to='/settings/role' title='Roles' hasBullet={true} />
            </>

          ) : null}


      </MenuInnerWithSub>
    </>
  )
}
